import { NgModule } from '@angular/core';

import { AuthGuard } from './utility/app.guard';
import { ErrorHandlerComponent } from './error-handler/error-handler/error-handler.component';
import { RouteMasterComponent } from './route-master/route-master.component';
import { CanDeactivateGuard } from './utility/can-exit.guard';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'error/:error',
    component: ErrorHandlerComponent,
  },
  {
    path: 'routes',
    component: RouteMasterComponent,
    canActivate: [AuthGuard],
    canDeactivate:[CanDeactivateGuard] 
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
